export default __webpack_public_path__ + "static/media/heart-result.51e13980.svg";